import {BottomSheet} from 'react-spring-bottom-sheet';
import cn from 'classnames';
import {rate} from '../../../contants';
import useGetStoreCommentsAndRateCounts from '../../../../../../services/hookService/getStoreCommentsAndRateCounts/useGetStoreCommentsAndRateCounts';

interface ICommentsAndRateBottomSheet {
  openCommentRateBottomSheet: boolean;
  setOpenCommentRateBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
}

const CommentsAndRateBottomSheet = ({
  openCommentRateBottomSheet,
  setOpenCommentRateBottomSheet,
}: ICommentsAndRateBottomSheet) => {
  const {data} = useGetStoreCommentsAndRateCounts();

  return (
    <BottomSheet
      onDismiss={() => setOpenCommentRateBottomSheet(false)}
      open={openCommentRateBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col p-3 ">
        <div className="flex justify-between mb-2">
          <span className="font-Medium">امتیاز فروشگاه من</span>
          <i
            className="icon-nameClose-remove"
            onClick={() => setOpenCommentRateBottomSheet(false)}
          />
        </div>
        {rate.map(item => (
          <div key={item.id} className="flex justify-between py-1">
            <span>
              {item.title} (
              {data?.rate_counts?.find(elem => elem.rate === item.id)?.count}{' '}
              نفر)
            </span>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].reverse().map((elem, index) => (
                <i
                  key={index}
                  className={cn('icon-nameStar text-xxl', {
                    'icon-namestar': index + 1 > item.id,
                    'icon-nameStar text-warning-500': index + 1 <= item.id,
                  })}
                />
              ))}
            </div>
          </div>
        ))}
        <div className="flex gap-3 mt-4">
          <div className="flex flex-1 items-center gap-2 shadow-md rounded py-3 px-2">
            <div className="flex justify-center items-center rounded-full p-2 bg-farm-shop-50 h-10 w-10">
              <i className="icon-namerate text-farm-shop-500 text-xxl font-bold" />
            </div>
            <div className="flex flex-col font-Medium text-md">
              <span>امتیاز فروشگاه</span>
              <span>{data?.rate}</span>
            </div>
          </div>
          <div className="flex items-center flex-1 gap-2 shadow-md rounded py-3 px-2">
            <div className="flex justify-center items-center rounded-full p-2 bg-farm-shop-50  h-10 w-10">
              <i className="icon-nameChats text-farm-shop-500 text-xxl font-bold" />
            </div>
            <div className="flex flex-col font-Medium text-md">
              <span>دیدگاه مشتریان</span>
              <span>{data?.comments_count} نفر</span>
            </div>
          </div>
        </div>
        <div className="width-full rounded py-3 bg-farm-shop-500">
          <button
            className="w-full text-white"
            onClick={() => setOpenCommentRateBottomSheet(false)}
          >
            متوجه شدم
          </button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CommentsAndRateBottomSheet;
